export default {
      id: "list-show-grey-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#list-show-grey",
      toString: function () {
        return this.url;
      }
    }